/**  
* Trendline.5.js
* created 11/01/2006 by Andrew Cattau 
* updated 7/09/2007 by Gregg Johnson 
* updated 3/06/2008 by Steven Racz
* added compatability for Events.3.js while retaining backwards compatability
* added event cancelling for text selection (strange issue when labels were visible in IE)
* updated 5/10/2012 by Neil McCorrison - jQuery 

 
TO DO:
- new formula to determine the infinite line
- fix the logic of the remove handles on resize
 
 
*/

/* Before we begin, a few words on style:
*
* Most of the objects that get created dynamically by this file don't have
* any explicit style associated with them.  In order for this file to work
* properly, the following CSS rule is required at a minimum:

.tl {
position: absolute;
background-color: #000000;  // Can be any color, but must be specified
line-height: 0;             // Needed for IE
font-size: 0;               // Needed for IE
}

* You can of course add any additional rules that you want to get the desired
* appearance.  Generally speaking, it isn't necessary to give z-indexes to the
* trendline elements- they are appended to the end of htmlElement, so they
* will appear above anything inside of htmlElment without an explicit z-index.
* Again, though, you can add one if necessary in your CSS file.  Second, in
* order for the positioning logic that we use here to work properly,
* htmlElement must be (either via CSS rule or explicit style assignment)
* "position: relative" (alternatively it must be positioned at the exact top
* left of another relatively positioned object).
*
* .tl is the class for the line segments.
*
* Other classes that you can style as you please:
* .TrendLineCanvas  // The div that will be used to detect mouse events
* .TrendlineHandle  // The images that will denote the trendline endpoints
* .TrendLabel       // The % label
*
* Lastly, there are a few other things you can configure via the object prototypes:
*
* // number of lines
* TrendLineCanvas.prototype.maxLines = 5;
*
* // className of line
* TrendLineCanvas.prototype.lineClassName = 'tl';
*
* // endpoint image
* TrendLine.prototype.imgHandleProps.src = '/gif/trendline/crosshair.gif';
* TrendLine.prototype.imgHandleProps.width = 6;
* TrendLine.prototype.imgHandleProps.height = 6;
* 
* // upon resize if the endpoint falls off the chart we display by default change below to true if you want to drop the image
* TrendLineCanvas.prototype.resizeDropEndPoint = false;
*
* // block the labels from displaying (default is set to false);
* TrendLine.prototype.blockTrendLabels = true;
*
* // label colors
* TrendLine.prototype.posColor = '#009900';
* TrendLine.prototype.negColor = '#990000';
*
*
* And now, usage:
*
* document.body.appendChild(
* 		Element.create('div', { 'id': 'ChartContainer', 'style': 'position:relative' }, [
* 			Element.create('img', { 'id': 'myChart', 'src': '/path/to/chart.gif' } )
* 		] )
* 	);
* var trendlines = new TrendLineCanvas(Element.get('ChartContainer'));
*
* // x and y values are relative to the top-left corner of your container.
* trendlines.setBounds(left, right, top, bottom);
* trendlines.setAxes(xMin, xMax, yMin, yMax);
*
* // If the size of your chart changes, (e.g. window resize), you have to update the canvas:
* trendlines.setPosition();
*
* // After calling any combination of the above, you can call 
* trendlines.resizeLines()
* // and all of your trendlines will be rescaled to fit the new size / limits.
* // Lines that cross the boundaries will be truncated, and lines entirely
* // outside the bounds will be deleted.  As an odd compatibility note, you
* // should not call resizeLines() from inside a window onresize event.  IE 6
* // can cause spurious onresize events when you click to draw a trendline.
* // After rescaling all of the lines on the canvas, resizeLines will clear
* // any lines with a 0 length, including your newly created line.  The result
* // is that the trendlines appear to just not work.  This is almost
* // impossible to detect, and even harder to work around, so just don't do
* // it.
*
* // Other functions:
*
* trendlines.hideLines();
* trendlines.showLines();
* trendlines.clearLines();
* // don't clear existing lines, but disable/enable drawing / editing.
* trendlines.disableCanvas();
* trendlines.enableCanvas();
*
* */

// TrendLineCanvas Object

function TrendLineCanvas(htmlElement) {
    this.canvasElement = $('<div />', { 'class': 'TrendLineCanvas', 'style': 'position:absolute;top:0;left:0' });
    this.ownerElement = htmlElement;
    this.ownerElement.append(this.canvasElement);

    // For some unknown reason, the Internet Explorer developers saw fit to
    // ignore event handlers on empty DIVs.  We can get around that by giving
    // the element a background-color, but we don't want it to cover our
    // original element.  Opacity to the rescue!
    // The browser detect here isn't strictly necessary, because the following
    // code will still work in other browsers.  But in this case it actually
    // feels less dirty to me than mucking around unnecessarily in well behaved
    // browsers.  Anyway, since there is really no penalty for mis-detection
    // here other than offending my aesthetic sense...
    if (navigator.userAgent.indexOf('MSIE') != -1) {
        this.canvasElement.css({ 'background-color': '#ffffff' });
        this.canvasElement.css({ 'opacity': 0 });
    }

    var width = this.ownerElement.outerWidth();
    var height = this.ownerElement.outerWidth();

    this.lines = [];
    this.currLine = null;

    this.setPosition();

    this.bounds = { 'top': 0,
        'right': width,
        'bottom': height,
        'left': 0,

        'width': width,
        'height': height
    };

    this.axes = {
        'xMinVal': 0,
        'xMaxVal': 0,
        'yMinVal': 0,
        'yMaxVal': 0,

        'xRange': 0,
        'yRange': 0
    };


    this.canvasElement.on('mousedown', $.proxy(this.beginDraw, this));
    this.canvasElement.on('dragstart', function (e) { e.preventDefault(); e.stopPropagation(); });
    this.canvasElement.on('selectstart', function (e) { e.preventDefault(); e.stopPropagation(); });


}

TrendLineCanvas.prototype.maxLines = 5;

TrendLineCanvas.prototype.lineClassName = "tl";

// User functions.  Use these to setup up the canvas to match your data.

TrendLineCanvas.prototype.setPosition = function () {

    this.canvasElement.css({
        width: this.ownerElement.outerWidth(),
        height: this.ownerElement.outerHeight()
    })

}

TrendLineCanvas.prototype.setBounds = function (left, right, top, bottom) {
    this.bounds = { 'left': left,
        'right': right,
        'bottom': bottom,
        'top': top,

        'width': right - left,
        'height': bottom - top
    };
}


TrendLineCanvas.prototype.setAxes = function (xMinVal, xMaxVal, yMinVal, yMaxVal) {
    this.axes = {
        'xMinVal': xMinVal,
        'xMaxVal': xMaxVal,
        'yMinVal': yMinVal,
        'yMaxVal': yMaxVal,

        'xRange': xMaxVal - xMinVal,
        'yRange': yMaxVal - yMinVal
    };
}

TrendLineCanvas.prototype.resizeLines = function () {
    // do the loop in reverse since some of the lines may fall out of the array
    // in the process
    for (var i = this.lines.length - 1; i >= 0; i--) {
        // calculate new coordinates
        var x1 = this.getXFromValue(this.lines[i].anchor.xVal);
        var x2 = this.getXFromValue(this.lines[i].drag.xVal);

        var y1 = this.getYFromValue(this.lines[i].anchor.yVal)
        var y2 = this.getYFromValue(this.lines[i].drag.yVal)

        // clip new coordinates to current viewable area
        var newCoords = this.checkClip(x1, x2, y1, y2);

        // if line has collapsed to a point, delete it.
        // else redraw it
        if (newCoords.x1 == newCoords.x2 && newCoords.y1 == newCoords.y2) {
            this.clearLine(this.lines[i]);

        } else {
            this.lines[i].setAnchorPos(newCoords.x1, newCoords.y1);
            this.lines[i].setDragPos(newCoords.x2, newCoords.y2);

            if (this.resizeDropEndPoint) {
                this.lines[i].setHandle(newCoords.leftHandle, newCoords.rightHandle);
            }

            this.lines[i].paint();
        }
    }
}

TrendLineCanvas.prototype.hideLines = function () {
    for (var i = 0; i < this.lines.length; i++) {
        this.lines[i].hide();
    }
}

TrendLineCanvas.prototype.showLines = function () {
    for (var i = 0; i < this.lines.length; i++) {
        this.lines[i].show();
    }
}

TrendLineCanvas.prototype.clearLines = function () {
    var line;
    while (line = this.lines.pop()) {
        line.clear();
    }
}

TrendLineCanvas.prototype.resizeDropEndPoint = false;

TrendLineCanvas.prototype.disableCanvas = function () {
    this.canvasElement.css({ display: 'none' });
}

TrendLineCanvas.prototype.enableCanvas = function () {
    this.canvasElement.css({ display: null });
}

// utility functions.
// These are mostly used internally, but they can be called by the end user if
// you need access to any of this data.

TrendLineCanvas.prototype.pctChg = function (a, b) {
    // From: http://barney.wallst.com/wsodwiki/index.php/QA:Rules_Based_QA
    // Calculating Percent Change
    //   1. The formula is: (New - Old) / Old
    //         1. Watch out when going from a negative number to another negative number or a positive number.
    //         2. If comparing two negative numbers, the smaller number should be an increase. This requires a change in the formula 
    // 
    var pct = Number.NaN;

    if (a > 0 && b >= 0) {
        pct = (b - a) / a;
    } else if (a < 0 && b < 0) {
        pct = -(b - a) / a;
    } else if (a == 0 && b == 0) {
        pct = 0;
    }

    if (!isNaN(pct)) {
        return (pct * 100).toFixed(2);
    } else {
        return '--';
    }
}

// Hey, algebra can actually be useful!
// (x - xMin) / (xMax - xMin) = (val - valMin) / (valMax - valMin)
// solve for val...
TrendLineCanvas.prototype.getValueFromX = function (relX) {
    var x = relX - this.bounds.left;
    var pct = x / this.bounds.width;
    var val = this.axes.xMinVal + pct * this.axes.xRange;

    return val;
}

// Now do the same thing, but solve for x...
TrendLineCanvas.prototype.getXFromValue = function (value) {
    var pct = (value - this.axes.xMinVal) / this.axes.xRange;
    var x = pct * this.bounds.width;
    var relX = x + this.bounds.left;

    return Math.round(relX);
}

// same idea, but slightly different, since yMin => valMax / yMax => valMin
// (y - yMin) / (yMax - yMin) = (valMax - val) / (valMax - valMin)
TrendLineCanvas.prototype.getValueFromY = function (relY) {
    var y = relY - this.bounds.top;
    var pct = y / this.bounds.height;
    var val = this.axes.yMaxVal - pct * this.axes.yRange;

    return val;
}

// now solve for y...
TrendLineCanvas.prototype.getYFromValue = function (value) {
    var pct = (this.axes.yMaxVal - value) / this.axes.yRange;
    var y = pct * this.bounds.height;
    var relY = y + this.bounds.top;

    return Math.round(relY);
}

// internal functions

TrendLineCanvas.prototype.checkClip = function (x1, x2, y1, y2) {
    var xMin = this.bounds.left;
    var xMax = this.bounds.right;
    var yMin = this.bounds.top;
    var yMax = this.bounds.bottom;
    var leftHandle = rightHandle = true;

    // if I make sure x1 is less than x2 now, i can reduce the number of checks to do later
    if (x1 > x2) {
        var _x = x1; x1 = x2; x2 = _x;
        var _y = y1; y1 = y2; y2 = _y;
    }

    /**
    * if the line is clipped then do not show the line handles
    */
    if (x1 < xMin || y1 < yMin || x2 < xMin || y2 < yMin) {
        leftHandle = false;
    }
    if (x1 > xMax || y1 > yMax || x2 > xMax || y2 > yMax) {
        rightHandle = false;
    }

    // if the line is entirely outside of the view area, collapse it to a single point.
    // it will then get cleaned up later.
    if (x1 < xMin && x2 < xMin) {
        x1 = xMin;
        x2 = xMin;
        y1 = y2;
    } else if (x1 < xMin) {
        // More fun with algebra.  And you thought this would never be useful...
        // we know x1,y1 and x2,y2.  We want to find the coordinate y' of the
        // line at an arbitrary x'.
        // (x' - x1) / (y' - y1) = (x2 - x1) / (y2 - y1)
        // solve for y'
        // in this case x' is xMin, and x' and y' become our new x1 and y1
        y1 = (y2 - y1) * (xMin - x1) / (x2 - x1) + y1;
        x1 = xMin;
    }

    if (x1 > xMax && x2 > xMax) {
        x1 = xMax;
        x2 = xMax;
        y2 = y1;
    } else if (x2 > xMax) {
        // same as before but this time, x' is xMax, and y' becomes y2
        y2 = (y2 - y1) * (xMax - x1) / (x2 - x1) + y1;
        x2 = xMax;
    }

    // again swap the endpoints (if necessary) so that y1 < y2
    if (y1 > y2) {
        var _x = x1; x1 = x2; x2 = _x;
        var _y = y1; y1 = y2; y2 = _y;
    }

    if (y1 < yMin && y2 < yMin) {
        y1 = yMin;
        y2 = yMin;
        x1 = x2;
    } else if (y1 < yMin) {
        // same equation.  this time solve for x' at a known y'
        x1 = (x2 - x1) * (yMin - y1) / (y2 - y1) + x1;
        y1 = yMin;
    }

    if (y1 > yMax && y2 > yMax) {
        y1 = yMax;
        y2 = yMax;
        x2 = x1;
    } else if (y2 > yMax) {
        // one last time...
        x2 = (x2 - x1) * (yMax - y1) / (y2 - y1) + x1;
        y2 = yMax;
    }

    return {
        'x1': Math.round(x1),
        'x2': Math.round(x2),
        'y1': Math.round(y1),
        'y2': Math.round(y2),

        'leftHandle': leftHandle,
        'rightHandle': rightHandle
    };

}

TrendLineCanvas.prototype.getNextLine = function () {
    // add a new line to the front of the array
    this.lines.unshift(new TrendLine(this));

    // if we're over the limit, remove one from the end.
    if (this.lines.length > this.maxLines) {
        var old = this.lines.pop();
        old.clear();
    }

    return this.lines[0];
}

TrendLineCanvas.prototype.clearLine = function (line) {
    line.clear();

    // remove the line from the array so it doesn't count against our limit.
    for (var i = 0; i < this.lines.length; i++) {
        if (this.lines[i] == line) {
            this.lines.splice(i, 1);
        }
    }
}

TrendLineCanvas.prototype.setDrawable = function (line) {
    this.currLine = line;

    line.beginDrag();

    // Danger, Will Robinson!!
    // Hopefully no one else has any 'onmouseup' event listeners on the document,
    // otherwise they are going to lose them when we clear this away later...


    $(document.body).on('mouseup.trendlines', $.proxy(this.endDraw, this));
    this.canvasElement.on('mousemove.trendlines', $.proxy(this.refresh, this));

}

TrendLineCanvas.prototype.unsetDrawable = function (line) {
    if (line) {

        this.canvasElement.off('mousemove.trendlines');
        $(document.body).off('mouseup.trendlines');

        line.endDrag(this.lineClassName);
        //line.lineClassNameStore = this.lineClassName;

        this.currLine = null;
    }
}

// event handlers

TrendLineCanvas.prototype.beginDraw = function (e) {
    this.disableTextSelect();

    e.preventDefault();
    e.stopPropagation();


    this.canvasOffset = this.canvasElement.offset();

    this.canvasOffset.left = Math.floor(this.canvasOffset.left);
    this.canvasOffset.top = Math.floor(this.canvasOffset.top);

    var relX = e.pageX - this.canvasOffset.left; //(evt.nativeEvent) ? evt.nativeEvent.layerX || evt.nativeEvent.offsetX : evt.layerX || evt.offsetX;
    var relY = e.pageY - this.canvasOffset.top; //(evt.nativeEvent) ? evt.nativeEvent.layerY || evt.nativeEvent.offsetY : evt.layerY || evt.offsetY;

    if (relX < this.bounds.left ||
		relX > this.bounds.right ||
		relY < this.bounds.top ||
		relY > this.bounds.bottom
	) {
        return;
    }

    var line = this.getNextLine();

    line.setAnchorPos(relX, relY);
    line.setDragPos(relX, relY);
    line.lineClassNameStore = this.lineClassName;
    line.paint();

    this.setDrawable(line);

}

TrendLineCanvas.prototype.grabHandle = function (e) {

    var line = e.data;
    element = e.currentTarget;

    console.info('grabHandle', element)

    // Move the line to the front of the list if it's not already there.  This
    // way the most recently edited line is treated the same as the most
    // recently created.  Mainly this is to keep a line that was just modified
    // from being cleaned up when the user hits their limit, as they are
    // probably more interested in the most recently modified, versus the most
    // recently created.
    for (var i = 1; i < this.lines.length; i++) {
        if (this.lines[i] == line) {
            this.lines.splice(i, 1);
            this.lines.unshift(line);
        }
    }

    // set the selected endpoint as the draggable end
    line.setDrag(element);

    this.setDrawable(line);

    // this should prevent selecting/dragging in non-IE
    e.preventDefault();
    e.stopPropagation();
}

TrendLineCanvas.prototype.refresh = function (e) {
    var element = e.currentTarget;


    if (!this.currLine) {
        return;
    } else {
        var line = this.currLine;
    }

    var relX = e.pageX - this.canvasOffset.left; //(evt.nativeEvent) ? evt.nativeEvent.layerX || evt.nativeEvent.offsetX : evt.layerX || evt.offsetX;
    var relY = e.pageY - this.canvasOffset.top; //(evt.nativeEvent) ? evt.nativeEvent.layerY || evt.nativeEvent.offsetY : evt.layerY || evt.offsetY;


    // there are really only two elements we could mouse over here, the canvas
    // or the label.  We added the mouseover handler to the label to prevent a
    // jarring stopp if the user move a little too fast.  If it's the label, we
    // have to take that into account when getting our position.
    if (element != this.canvasElement) {
        relX += parseInt(element.style.left);
        relY += parseInt(element.style.top);
    }

    if (relX < this.bounds.left ||
		relX > this.bounds.right ||
		relY < this.bounds.top ||
		relY > this.bounds.bottom
	) {
        return;
    }

    line.setDragPos(relX, relY);
    line.lineClassNameStore = this.lineClassName;
    line.paint();
}

TrendLineCanvas.prototype.endDraw = function (e) {
    this.enableTextSelect();

    this.unsetDrawable(this.currLine);
}

TrendLineCanvas.prototype.disableTextSelect = function () {
    if (!document.onselectstart) {
        document.onselectstart = function () {
            return false;
        };
    }
};

TrendLineCanvas.prototype.enableTextSelect = function () {
    if (document.onselectstart) {
        document.onselectstart = null;
    }
};


// TrendLine Object

function TrendLine(owner) {
    this.handleOffsetX = Math.floor(this.imgHandleProps.width / 2) - 1;
    this.handleOffsetY = Math.floor(this.imgHandleProps.height / 2) - 1;

    this.ownerCanvas = owner;

    this.createCanvas();
    if (!this.blockTrendLabels) {
        this.createLabel();
    }
    this.createHandles();

    this.segments = [];
}

TrendLine.prototype.imgHandleProps = { 'src': '/gif/trendline/crosshair.gif',
    'class': 'TrendlineHandle',
    'height': 6,
    'width': 6,
    'style': 'position:absolute'
};
TrendLine.prototype.posColor = '#009900';
TrendLine.prototype.negColor = '#990000';

// Don't Change ME!!
TrendLine.prototype.lineRegex = /%(\d+);(\d+);(\d+);(\d+)/g;

// 'Public' interface

TrendLine.prototype.reset = function () {
    this.drag.css({ display: null });
    this.anchor.css({ display: null });
    this.canvas.css({ display: null });
    if (!this.blockTrendLabels) {
        this.label.css({ display: null });
    }
}

TrendLine.prototype.setHandle = function (left, right) {
    if (!left)
        this.anchor.css({ display: 'none' });
    if (!right)
        this.drag.css({ display: 'none' });


}

TrendLine.prototype.setDrag = function (handle) {
    this.drag = (handle == this.handles['a'][0]) ? this.handles['a'] : this.handles['b'];
    this.anchor = (handle == this.handles['a'][0]) ? this.handles['b'] : this.handles['a'];
}

TrendLine.prototype.isInfinite = false;

/**
* not really infinite just setting a Max and Min value that can never be reach via the chart
*/
TrendLine.prototype.setInfiniteTrend = {
    'min': 0,
    'max': 0
}


TrendLine.prototype.createInfiniteTrend = function () {
    if (this.anchor._x > this.drag._x) {
        var x1 = this.drag._x;
        var x2 = this.anchor._x;
        var y1 = this.drag._y;
        var y2 = this.anchor._y;
    } else {
        var x2 = this.drag._x;
        var x1 = this.anchor._x;
        var y2 = this.drag._y;
        var y1 = this.anchor._y;
    }

    // find the X coordinate given the min and max X values (MS Date usually)
    minX = this.ownerCanvas.getXFromValue(this.setInfiniteTrend.min);
    maxX = this.ownerCanvas.getXFromValue(this.setInfiniteTrend.max);

    /*
    x1 = 23;
    y1 = 205;
    x2 = 68;
    y2 = 198;
	
    minX = x1;
    maxX = x2; 
    */

    // find the slope
    this.slope = (y2 - y1) / (x2 - x1);

    // find min and max y	
    maxY = this.slope * (maxX - x2) + y2;
    minY = (-1 * (this.slope * (x1 - minX))) + y1;

    if (0 == this.slope) {
        minY = maxY;
    }

    //console.log("slope: " + this.slope);
    //console.log("Anchor: " + minX + ", " + minY);
    //console.log("Drag: " + maxX + ", " + maxY);
    this.ownerCanvas.resizeLines();

    // clip new coordinates to current viewable area
    var newCoords = this.ownerCanvas.checkClip(minX, maxX, minY, maxY);

    // if line has collapsed to a point, delete it.
    // else redraw it
    if (newCoords.x1 == newCoords.x2 && newCoords.y1 == newCoords.y2) {
        this.clear();

    } else {
        this.setAnchorPos(newCoords.x1, newCoords.y1);
        this.setDragPos(newCoords.x2, newCoords.y2);

        if (this.resizeDropEndPoint) {
            this.setHandle(newCoords.leftHandle, newCoords.rightHandle);
        }

        this.paint();
    }

}

TrendLine.prototype.setAnchorPos = function (x, y) {
    //console.log(x + ", " + y);
    this.anchor._x = x;
    this.anchor._y = y;

    this.anchor.xVal = this.ownerCanvas.getValueFromX(x);
    this.anchor.yVal = this.ownerCanvas.getValueFromY(y);

    this.anchor.css({ top: y - this.handleOffsetY });
    this.anchor.css({ left: x - this.handleOffsetX });

}

TrendLine.prototype.setDragPos = function (x, y) {
    this.drag._x = x;
    this.drag._y = y;

    this.drag.xVal = this.ownerCanvas.getValueFromX(x);
    this.drag.yVal = this.ownerCanvas.getValueFromY(y);

    this.drag.css({ top: y - this.handleOffsetY });
    this.drag.css({ left: x - this.handleOffsetX });
}

TrendLine.prototype.beginDrag = function () {
    // Totally an aesthetic decision on my part, but I like it better if the
    // handle is not in the way (visibly) when I'm dragging it.
    // And since I wrote the code, all you suckers are stuck with it :-P
    this.drag.css({ display: 'none' });

    if (!this.blockTrendLabels) {

        this.label.on('mousemove.trendlines', $.proxy(this.ownerCanvas.refresh, this.ownerCanvas))

    }
}

TrendLine.prototype.endDrag = function () {
    if (Math.abs(this.drag._x - this.anchor._x) < this.imgHandleProps.width &&
		Math.abs(this.drag._y - this.anchor._y) < this.imgHandleProps.height
	) {
        // have the canvas clean us up so that we get removed from the list of lines...
        this.ownerCanvas.clearLine(this);
    } else {
        this.drag.css({ display: '' });
    }

    if (this.isInfinite) {
        this.createInfiniteTrend();

    }

    if (!this.blockTrendLabels) {

        this.label.off('mousemove.trendlines');

    }
}

TrendLine.prototype.lineClassNameStore = 'tl3';
TrendLine.prototype.blockTrendLabels = false;

TrendLine.prototype.paint = function () {
    this.segments = [];
    this.makeLine(this.anchor._x, this.anchor._y,
					this.drag._x, this.drag._y, this.segments);

    //console.info('canvas',this.canvas)

    var html = this.segments.join("").replace(this.lineRegex, '<div class="trendClass" style="left:$1px;top:$2px;width:$3px;height:$4px;"></div>').replace(/trendClass/g, this.lineClassNameStore);
    this.canvas.html(html);

    if (!this.blockTrendLabels) {
        if (this.anchor._x <= this.drag._x) {
            this.label.html(this.ownerCanvas.pctChg(this.anchor.yVal, this.drag.yVal));
            this.label.css({ top: this.drag._y - this.label.outerHeight() });
            this.label.css({ left: this.drag._x + 8 })
        } else {
            this.label.html(this.ownerCanvas.pctChg(this.drag.yVal, this.anchor.yVal));
            this.label.css({ top: this.anchor._y - this.label.outerHeight() });
            this.label.css({ left: this.anchor._x + 8 });
        }

        if (this.label.innerHTML > 0) {
            this.label.css({ color: this.posColor });
        } else if (this.label.innerHTML < 0) {
            this.label.css({ color: this.negColor });
        } else {
            this.label.css({ color: '' });
        }

        var html = this.label.html();

        if (html != '--') {
            this.label.html(html + '%');
        }
    }
}

TrendLine.prototype.hide = function () {
    if (!this.blockTrendLabels) {
        this.label.css({ display: 'none' });
    }

    this.canvas.css({ display: 'none' });
    this.anchor.css({ display: 'none' });
    this.drag.css({ display: 'none' });

}

TrendLine.prototype.show = function () {
    if (!this.blockTrendLabels) {
        this.label.css({ display: null });
    }

    this.canvas.css({ display: null });
    this.anchor.css({ display: null });
    this.drag.css({ display: null });

}

TrendLine.prototype.clear = function () {
    if (!this.blockTrendLabels) {
        this.label.remove();
    }
    this.canvas.remove();
    this.anchor.remove();
    this.drag.remove();
}

// Internal functions

TrendLine.prototype.createHandles = function () {
    this.handles = {
        'a': $('<img />', this.imgHandleProps),
        'b': $('<img />', this.imgHandleProps)
    };

    this.handles['a']._x = 0; this.handles['a']._y = 0;
    this.handles['b']._x = 0; this.handles['b']._y = 0;

    this.handles['a'].on('mousedown', this, $.proxy(this.ownerCanvas.grabHandle, this.ownerCanvas));
    this.handles['b'].on('mousedown', this, $.proxy(this.ownerCanvas.grabHandle, this.ownerCanvas));

    this.handles['a'].on('dragstart', function (e) { e.preventDefault(); e.stopPropagation(); });
    this.handles['b'].on('dragstart', function (e) { e.preventDefault(); e.stopPropagation(); });


    this.anchor = this.handles['a'];
    this.drag = this.handles['b'];

    this.ownerCanvas.ownerElement.append(this.handles['a']);
    this.ownerCanvas.ownerElement.append(this.handles['b']);
}

TrendLine.prototype.createLabel = function () {
    this.label = $('<span />', { 'class': 'TrendLabel', 'style': 'position:absolute' })
    this.ownerCanvas.ownerElement.append(this.label);
}

TrendLine.prototype.createCanvas = function () {
    this.canvas = $('<div />')
    this.ownerCanvas.ownerElement.append(this.canvas);
}

// this is all black magic to me, but it seems to work as advertised,
// so I'm not gonna mess with it.

/*based on mkLine() from wz_jsgraphics.js  v. 2.3;Copyright (c) 2002-2004 Walter Zorn. All rights reserved.;Created 3. 11. 2002 by Walter Zorn (Web: http://www.walterzorn.com );Performance optimizations for Internet Explorer;by Thomas Frank and John Holdsworth;This program is free software;you can redistribute it and/or modify it under the terms of the GNU General Public License as published by the Free Software Foundation;either version 2 of the License, or (at your option) any later version.This program is distributed in the hope that it will be useful,but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.See the GNU General Public License at http://www.gnu.org/copyleft/gpl.html for more details.*/
TrendLine.prototype.makeLine = function (x1, y1, x2, y2, segments) {
    if (x1 > x2) {
        _x2 = x2;
        _y2 = y2;
        x2 = x1;
        y2 = y1;
        x1 = _x2;
        y1 = _y2;
    }

    dx = x2 - x1;
    dy = Math.abs(y2 - y1);
    x = x1;
    y = y1;
    yIncr = (y1 > y2) ? -1 : 1;
    if (dx >= dy) {
        pr = dy << 1;
        pru = pr - (dx << 1);
        p = pr - dx;
        ox = x;
        while ((dx--) > 1) {
            ++x;
            if (p > 0) {
                segments[segments.length] = '%' + ox + ';' + y + ';' + (x - ox) + ';2';
                y += yIncr;
                p += pru;
                ox = x;
            }
            else { p += pr; }
        }
        segments[segments.length] = '%' + ox + ';' + y + ';' + (x2 - ox + 2) + ';2';
    }
    else {
        pr = dx << 1;
        pru = pr - (dy << 1);
        p = pr - dy;
        oy = y;
        if (y2 <= y1) {
            while ((dy--) > 1) {
                if (p > 0) {
                    segments[segments.length] = '%' + (x++) + ';' + y + ';2;' + (oy - y + 2);
                    y += yIncr;
                    p += pru;
                    oy = y;
                }
                else {
                    y += yIncr;
                    p += pr;
                }
            }
            segments[segments.length] = '%' + x2 + ';' + y2 + ';2;' + (oy - y2 + 2);
        }
        else {
            while ((dy--) > 1) {
                y += yIncr;
                if (p > 0) {
                    segments[segments.length] = '%' + (x++) + ';' + oy + ';2;' + (y - oy);
                    p += pru; oy = y;
                }
                else { p += pr; }
            }
            segments[segments.length] = '%' + x2 + ';' + oy + ';2;' + (y2 - oy + 2);
        }
    }
}
